// extracted by mini-css-extract-plugin
export default {"statusFlag":"InvoiceDetailsPage_statusFlag__lSS9v"};